<template>
    <div>
        <v-layout
            v-if="!rewards.length"
            justify-center
            align-center
            class="my-4 headline"
        >
            No Rewards
        </v-layout>
        <div class="mt-4">
            <v-layout justify-start class="mb-3 ml-4 px-2">
                <v-btn-toggle
                    mandatory
                    v-model="rewardsMode"
                    class="toggle-button-group"
                >
                    <v-btn
                        flat
                        value="history"
                        class="toggle-button rewards-history-button"
                    >
                        History
                    </v-btn>
                    <v-btn
                        flat
                        value="earn"
                        class="toggle-button rewards-earn-button"
                    >
                        Can Earn
                    </v-btn>
                </v-btn-toggle>
            </v-layout>
            <div v-if="rewardsMode == 'history'">
                <div
                    class="px-4 ml-4 pt-3"
                    v-for="(reward, index) in rewards"
                    v-if="rewards.length"
                >
                    <v-layout row class="">
                        <div style="width: 150px;">
                            {{ reward.date | date }}
                        </div>
                        <div style="width: 250px;" v-if="reward.redeemType">
                            Redeemed towards
                            <strong>{{ reward.redeemType }}</strong>
                        </div>
                        <div v-if="!reward.redeemType" style="width: 250px;">
                            <div>{{ reward.description }}</div>
                        </div>
                        <div
                            style="width: 100px;"
                            class="text-xs-right font-weight-medium"
                        >
                            {{ reward.amount | currency }}
                        </div>
                    </v-layout>
                    <v-divider class="pb-1 mt-2"></v-divider>
                </div>
                <v-layout
                    v-if="rewards.length"
                    row
                    class="mt-1 ml-4 px-2 title text-success"
                    justify-space-between
                    style="width: 520px;"
                >
                    <div class="font-weight-medium">
                        Total Available
                    </div>
                    <div class="font-weight-medium text-xs-right mr-0">
                        {{ getTotalAvailable() | currency }}
                    </div>
                </v-layout>
            </div>
            <div v-if="rewardsMode == 'earn'">
                <v-layout row class="font-weight-medium px-2 ml-4 pt-3">
                    <div style="width: 150px;">
                        Date
                    </div>
                    <div style="width: 200px;">
                        Description
                    </div>
                    <div
                        style="width: 100px;"
                        class="text-xs-right font-weight-medium"
                    >
                        Billed
                    </div>
                    <div
                        style="width: 150px;"
                        class="text-xs-right font-weight-medium"
                    >
                        Earn
                    </div>
                    <div
                        style="width: 150px;"
                        class="text-xs-right font-weight-medium"
                    >
                        With Autopay
                    </div>
                </v-layout>
                <v-divider class="pb-1 mt-2"></v-divider>
                <div
                    class="px-4 ml-4 pt-3"
                    v-for="(reward, index) in rewardsToEarn"
                    v-if="rewardsToEarn.length"
                >
                    <v-layout row class="">
                        <div style="width: 150px;">
                            {{ reward.date | date }}
                        </div>
                        <div style="width: 200px;">
                            {{ reward.description }}
                        </div>
                        <div
                            style="width: 100px;"
                            class="text-xs-right font-weight-medium"
                        >
                            {{ reward.amount | currency }}
                        </div>
                        <div
                            style="width: 150px;"
                            class="text-xs-right font-weight-medium text-success"
                        >
                            {{ reward.earn | currency }}
                        </div>
                        <div
                            v-if="reward.autopayEarn"
                            style="width: 150px;"
                            class="text-xs-right font-weight-medium text-success"
                        >
                            {{ reward.autopayEarn | currency }}
                        </div>
                        <div
                            v-if="!reward.autopayEarn"
                            style="width: 100px;"
                        ></div>
                    </v-layout>
                    <v-divider class="pb-1 mt-2"></v-divider>
                </div>
                <v-layout
                    v-if="rewardsToEarn.length"
                    row
                    class="mt-1 mr-3 ml-4 px-2 title text-success"
                    justify-space-between
                    style="width: 720px;"
                >
                    <div class="font-weight-medium ml-2">
                        Total To Earn
                    </div>
                    <div class="font-weight-medium text-xs-right mr-0">
                        {{ getTotalToEarn() | currency }}
                    </div>
                </v-layout>
            </div>
        </div>
    </div>
</template>
<script>
import { formatPhoneNumber, sum } from "../../utils/helpers.js";
export default {
    props: {
        accountID: String,
    },
    data() {
        return {
            rewards: [],
            rewardsToEarn: [],
            rewardsMode: "history",
            total: 0,

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    watch: {
        // accountID(newValue, oldValue) {
        //     if (newValue) {
        //         this.loadCallbackRequests();
        //     }
        // },
    },
    async created() {
        this.loadRewards();
        this.loadRewardsToEarn();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        async loadRewards() {
            const rewards = await this.$http.get(
                "api/rewards/GetRewardsList?accountID=" + this.accountID
            );

            this.rewards = rewards;
        },
        getTotalAvailable() {
            if (!this.rewards.length) return 0;

            return sum(this.rewards.map((r) => r.amount));
        },
        async loadRewardsToEarn() {
            const rewardsToEarn = await this.$http.get(
                "api/rewards/GetRewardsToEarn?accountID=" + this.accountID
            );

            this.rewardsToEarn = rewardsToEarn;
        },
        getTotalToEarn() {
            if (!this.rewardsToEarn.length) return 0;

            return sum(this.rewardsToEarn.map((r) => +r.earn + +r.autopayEarn));
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group {
    border-radius: 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #afecb2 !important;
    color: #4caf50 !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.rewards-history-button {
    border-radius: 10px 0px 0px 10px;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active.rewards-earn-button {
    border-radius: 0px 10px 10px 0px;
}
</style>
